<template>
  <div v-if="!isLoadingInit" class="majority-block">
    <!-- name -->
    <b-row class="mt-2 mb-5">
      <b-col cols="12" sm="6" class="mb-2">
        <label>{{ $t("general.majority_name") }} :</label>
        <b-form-input v-model="majority.name" />
      </b-col>
      <b-col cols="12" sm="6">
        <div class="d-flex align-items-center h-100">
          <label><strong>Applicable pour toutes les copropriétés</strong></label>
          <b-form-checkbox v-model="majority.is_general" class="d-inline mx-3" switch />
        </div>
      </b-col>
    </b-row>

    <h6>{{ $t("general.accepte_resolution_must") }} :</h6>

    <!-- rules -->
    <b-row v-for="(rule, index) in majority.majority_conditions.rules" :key="index">
      <b-col>
        <appRules
          :majority="majority"
          :rule="rule"
          :index="index"
          @deleteRule="deleteRule"
          @addRule="addRule"
          @deleteRevoteRule="deleteRevoteRule"
          @addRevoteRule="addRevoteRule"
        />
      </b-col>
    </b-row>
    <!-- revote -->
    <b-row class="mt-5 mb-3">
      <b-col cols="12">
        <label><strong>Possibilité de revote à une majorité différente ?</strong></label>
        <b-form-checkbox
          v-model="majority.majority_conditions.revote"
          class="d-inline mx-3"
          switch
        />
      </b-col>
    </b-row>
    <b-row v-if="majority.majority_conditions.revote">
      <b-col>
        <!-- another majority -->
        <b-row class="my-3">
          <b-col>
            <span>Pour être revoté a la majorité</span> &nbsp;
            <b-form-select
              v-model="majority.majority_conditions.revoteMajority"
              class="w-auto"
              :options="majoritiesOptions"
            />
            <span>, la résolution doit recueillir :</span>
          </b-col>
        </b-row>
        <!-- revote rules -->
        <b-row v-for="(rule, index) in majority.majority_conditions.revoteRules" :key="index">
          <b-col>
            <appRules
              :is-revote="true"
              :majority="majority"
              :rule="rule"
              :index="index"
              @deleteRule="deleteRule"
              @addRule="addRule"
              @deleteRevoteRule="deleteRevoteRule"
              @addRevoteRule="addRevoteRule"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- cancel, create, update -->
    <b-row class="mt-5 mb-2 d-flex justify-content-end">
      <b-col cols="auto">
        <b-button class="button btn-red" @click="cancel">
          <font-awesome-icon class="agv-button-icon" icon="times-circle" />
          <span>{{ $t("general.cancel") }}</span>
        </b-button>
      </b-col>
      <b-col cols="auto">
        <b-button
          v-if="isNew"
          :disabled="isLoadingSave"
          class="button btn-blue"
          @click="CREATE_MAJORITY"
        >
          <font-awesome-icon v-if="!isLoadingSave" class="agv-button-icon" icon="save" />
          <font-awesome-icon v-else class="agv-button-icon" icon="spinner" pulse />
          <span>{{ $t("general.enregistrer") }}</span>
        </b-button>
        <b-button v-else :disabled="isLoadingSave" class="button btn-blue" @click="UPDATE_MAJORITY">
          <font-awesome-icon v-if="!isLoadingSave" class="agv-button-icon" icon="save" />
          <font-awesome-icon v-else class="agv-button-icon" icon="spinner" pulse />
          <span>{{ $t("general.enregistrer") }}</span>
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-if="errorsOnUpdate" cols="12">
        <div class="mt-3 text-danger">
          <div>
            <strong
              >Comme les réunions suivantes ne sont pas terminées, cette majorité ne peut pas être
              modifiée
            </strong>
          </div>

          {{ errorsOnUpdate }}
        </div>
      </b-col>
    </b-row>
  </div>
  <appLoader v-else />
</template>

<script>
import MajorityMW from "@/middlewares/Majority";
import MajorityORM from "@/store/orm-axios/models/Majority";

import BuildingMW from "@/middlewares/Building";
import BuildingORM from "@/store/orm-axios/models/Building";

import appRules from "./Rules";
import { validate } from "vee-validate";

export default {
  components: {
    appRules,
  },
  props: {
    isNew: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isLoadingInit: true,
      isLoadingSave: false,
      majority: {
        agency_id: Number(localStorage.getItem("agencyId")),
        name: "",
        is_general: true,
        // slug: "",
        majority_conditions: {
          rules: [
            {
              majorityType: "1",
              forOrAgainst: "1", // ???: ..
              operators: ">",
              percent: "25",
              denominator: "1",
              cumulMandates: "1",
            },
          ],
          rulesOperator: "1", // ..
          revote: false,
          revoteRules: [
            // ..
            {
              majorityType: "1",
              forOrAgainst: "1", // ???: ..
              operators: ">",
              percent: "25",
              denominator: "1",
              cumulMandates: "1",
            },
          ],
          revoteRulesOperator: "1", // ..
          revoteMajority: "",
        },
      },
      defaultMajorityRule: {
        majorityType: "1",
        forOrAgainst: "1", // ???: ..
        operators: ">",
        percent: "25",
        denominator: "1",
        cumulMandates: "1",
      },
      errorsOnUpdate: null,
    };
  },
  computed: {
    majoritiesOptions() {
      let majorities = MajorityORM.query().where("agency_id", this.agencyId).get();
      let majoritiesOptions = [];
      majoritiesOptions.push({
        text: "",
        value: "",
      });
      majorities.forEach(majority => {
        majoritiesOptions.push({
          text: majority.name,
          value: majority.id,
        });
      });
      return majoritiesOptions;
    },
    buildingsOptions() {
      return BuildingORM.query().where("agency_id", this.agencyId).orderBy("created", "desc").get();
    },
  },
  async created() {
    await MajorityMW.FETCH();

    if (!this.isNew) {
      await MajorityMW.GET(this.$route.params.id)
        .then(res => {
          this.isLoadingInit = false;
          this.majority = MajorityORM.query().where("id", this.$route.params.id).first();
        })
        .catch(err => {
          this.isLoadingInit = false;
          console.log("error", err);
        });
    } else {
      this.isLoadingInit = false;
    }

    const buildingProperties = ["id", "name", "agency_id", "created"];
    await BuildingMW.QUERY_FETCH_PROPERTIES(this.agencyId, buildingProperties);
  },
  methods: {
    deleteRule() {
      this.majority.majority_conditions.rules.pop();
    },
    addRule() {
      this.majority.majority_conditions.rules.push(
        JSON.parse(JSON.stringify(this.defaultMajorityRule))
      );
    },
    deleteRevoteRule() {
      this.majority.majority_conditions.revoteRules.pop();
    },
    addRevoteRule() {
      this.majority.majority_conditions.revoteRules.push(
        JSON.parse(JSON.stringify(this.defaultMajorityRule))
      );
    },
    cancel() {
      this.$router.push({ name: "majorities" });
    },
    async CREATE_MAJORITY() {
      this.prepareMajorityData();
      this.isLoadingSave = true;
      MajorityMW.POST(this.majority)
        .then(res => {
          this.isLoadingSave = false;
          this.$router.push({ name: "majorities" });
        })
        .catch(err => {
          this.isLoadingSave = false;
          console.log("err", err);
        });
    },
    async UPDATE_MAJORITY() {
      this.prepareMajorityData();
      this.isLoadingSave = true;
      MajorityMW.CUSTOM_UPDATE(this.majority)
        .then(res => {
          this.isLoadingSave = false;
          this.$router.push({ name: "majorities" });
        })
        .catch(err => {
          this.isLoadingSave = false;
          if (err.response.data && err.response.data["hydra:description"]) {
            let parsedError = JSON.parse(err.response.data["hydra:description"]);
            this.errorsOnUpdate = parsedError.join(", ");
          }
        });
    },
    prepareMajorityData() {
      if (!this.majority.is_general) {
        this.majority.is_general = false;
      }
    },
  },
};
</script>
